var _stop, _stop2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgCollectionTime = function SvgCollectionTime(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id, ")"),
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m2 6.167 9.23-3.846a2 2 0 0 1 1.54 0L17 4.083l5 2.084m-20 0L7 8.25M2 6.167V10.5m10-.167V22m0-11.667 10-4.166m-10 4.166L7 8.25M12 22l-9.385-3.91A1 1 0 0 1 2 17.167V13.5M12 22l9.385-3.91a1 1 0 0 0 .615-.923v-11M7 8.25l6.5-2.75"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 2,
    x2: 22,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgCollectionTime;